import Promise from 'bluebird';
import VisionPlanService from 'web-core/src/vision-plan-service';
import PlanUtils from 'web-core/src/utils/plan';
import AddressUtils from 'web-core/src/utils/address';

import clientConf from '../../conf';

export const RECEIVE_PLANS = 'RECEIVE_VISION_PLANS';
export const RECEIVE_DETAILS = 'RECEIVE_VISION_DETAILS';
export const RECEIVE_EFFECTIVE_DATE = 'RECEIVE_VISION_EFFECTIVE_DATE';

export const receivePlans = plans => ({
  type: RECEIVE_PLANS,
  plans,
});

export const receiveDetails = details => ({
  type: RECEIVE_DETAILS,
  details,
});

export const receiveEffectiveDate = effectiveDate => ({
  type: RECEIVE_EFFECTIVE_DATE,
  effectiveDate,
});

const getConf = () => ({
  path: {
    searchBase: `${clientConf.MARKETPLACE_BASE_URL}/v1`,
  },
});

const internalFetchPlans = ({
  address,
  appMembers,
  buyDate,
  planYear,
  visionService,
  dispatch,
}) => {
  // https://stridehealth.atlassian.net/browse/IHOP-135
  // person doesn't have an age column, just dob
  // and we don't crete a quote for vision plans (quoteApplicant does store age)
  // Age currently doesn't have an effect on vision plan eligibility + premium
  // so we can temporarily set to 18 so the request succeeds.
  // The user will supply DoB in the enrollment flow.
  // PlanUtils.getMemberParams is returning null for age when dob isn't already set
  // e.g. 'pnullf,snullf,nullf'
  const appParams = {
    ...AddressUtils.toRequestGeo(address),
    demos: PlanUtils.getMemberParams(appMembers).replace(/null/g, '18'),
  };

  return visionService.getEligible(appParams, buyDate, planYear).then((response) => {
    dispatch(receiveEffectiveDate(response.effectiveDate));
    dispatch(receivePlans(response.plans));
    return response;
  });
};

export const fetchPlans = ({ address, appMembers, buyDate, planYear }) => (
  dispatch,
  getState,
  { apiClient },
) => {
  const visionService = new VisionPlanService({ client: apiClient, conf: getConf() });
  return internalFetchPlans({ address, appMembers, buyDate, planYear, visionService, dispatch });
};

const internalFetchDetails = ({ id, visionService, dispatch }) =>
  visionService.getDetails(id).then((response) => {
    const plan = { ...response, carrier: 'Renaissance' };
    dispatch(receiveDetails(plan));
    return plan;
  });

export const fetchDetails = id => (dispatch, getState, { apiClient }) => {
  const svc = new VisionPlanService({ client: apiClient, conf: getConf() });

  return svc.getDetails(id).then((response) => {
    dispatch(receiveDetails(response));
    return response;
  });
};

export const fetchBundle = ({ address, appMembers, buyDate, planYear }) => (
  dispatch,
  getState,
  { apiClient },
) => {
  const visionService = new VisionPlanService({ client: apiClient, conf: getConf() });
  return internalFetchPlans({ address, appMembers, buyDate, planYear, visionService, dispatch })
    .then(response =>
      Promise.map(response.plans, plan =>
        internalFetchDetails({ id: plan.id, visionService, dispatch })))
    .then(() => getState().visionPlans.plans);
};
